import LocalStorage from 'services/LocalStorage'
import { is24meApp, isGroupcalApp } from './appType'
import { LocalStorageKey } from 'types/services/localStorage'

export function provideGoogleClientIdPerStagePerApp() {
  let clientId: string | undefined = undefined
  let stage = LocalStorage.get(LocalStorageKey.APP_HOST) ?? ''

  if (isGroupcalApp()) {
    switch (stage) {
      case 'https://stage001.twentyfour.me':
        clientId =
          '360266039864-1l1t8dvct3g3s4ejvibp7ptntecf77v2.apps.googleusercontent.com'
        break
      case 'https://stage002.twentyfour.me':
        clientId =
          '360266039864-4b54vcuiahm87tvbvruu13a7gpl232m5.apps.googleusercontent.com'
        break
      case 'https://stage003.twentyfour.me':
        clientId =
          '360266039864-bph0dm7517r2pefv8uq6q2nl1bk5i8dd.apps.googleusercontent.com'
        break
      default:
        clientId =
          '360266039864-nj0f80ho1c1fgtf5vth9c5egh8sfs8ig.apps.googleusercontent.com'
        break
    }
  } else if (is24meApp()) {
    switch (stage) {
      case 'https://stage001.twentyfour.me':
        clientId =
          '641652799786-uufh4e9bajh08hdbk9p5nu08tldm4mgd.apps.googleusercontent.com'
        break
      case 'https://stage002.twentyfour.me':
        clientId =
          '641652799786-gjdu31tsth0mm3407hk92e7vofcqdn8a.apps.googleusercontent.com'
        break
      case 'https://stage003.twentyfour.me':
        clientId =
          '641652799786-gvdj26j29obkqtku9ngsru8ti8fc97qp.apps.googleusercontent.com'
        break
      default:
        clientId =
          '641652799786-ueppvu6n05r27svcr5fd5vhge40iahgo.apps.googleusercontent.com'
        break
    }
  }

  return clientId
}
